export default __webpack_public_path__ + "static/fonts/PFBagueSansPro-Regular-K6AFSYIN.woff2!static";